import { LAYOUT_TYPES } from '@/config/app';
import { getDeviceType } from '@/utils/device';
import { debounce } from '@/utils/timing';

export class DeviceStore {
    private device = 'mobile';

    constructor() {
        this.init();
    }

    init() {
        this.handleResize = this.handleResize.bind(this);
        this.handleResize();
        window.addEventListener('resize', debounce(this.handleResize, 300));
    }

    isMobile() {
        return this.device === LAYOUT_TYPES.MOBILE;
    }

    isTablet() {
        return this.device === LAYOUT_TYPES.TABLET;
    }

    isDesktop() {
        return this.device === LAYOUT_TYPES.DESKTOP;
    }

    handleResize() {
        this.device = getDeviceType();
    }

    destroy() {
        window.removeEventListener('resize', debounce(this.handleResize, 300));
    }
}
